export const ACTION_TYPES = {
  SET_CMS_CONTENT: 'cms/SET_CMS_CONTENT',
  SET_CMS_CREATED: 'cms/SET_CMS_CREATED',
  SET_ERROR: 'cms/SET_ERROR',
  SET_MARKETING: 'cms/SET_MARKETING',
  DATA_LOADING: 'cms/DATA_LOADING',
  DATA_LOADED: 'cms/DATA_LOADED'
};

export const setCmsCreated = () => {
  return {
    type: ACTION_TYPES.SET_CMS_CREATED
  };
};

export const setCmsContent = ({ content, type }) => {
  return {
    type: ACTION_TYPES.SET_CMS_CONTENT,
    payload: { content, type }
  };
};

export const setMarketing = (data: any) => {
  return {
    type: ACTION_TYPES.SET_MARKETING,
    payload: data
  };
};

export const dataLoading = () => {
  return {
    type: ACTION_TYPES.DATA_LOADING
  };
};

export const dataLoaded = () => {
  return {
    type: ACTION_TYPES.DATA_LOADED
  };
};
